import { isEditableUserUtil } from 'models/daos/user/utils'
import { ROUTE_PATHS_WITHOUT_SIDEBAR } from 'modules/routes/constants/index.cjs'
import isEditRouteUtil from 'modules/routes/utils/is-edit'
import isNewRouteUtil from 'modules/routes/utils/is-new'
import isAppRouteUtil from 'modules/routes/utils/is-app'

/**
 * Checks whether the current pathname should have the <SideBar>.
 * @param  {string}  pathname
 * @returns {boolean}
 */
function hasSideBarRouteUtil (pathname) {
  return !isAppRouteUtil(pathname) && (
    !ROUTE_PATHS_WITHOUT_SIDEBAR.some(pathWithoutSubNavBar => pathname === pathWithoutSubNavBar)
  )
}

/**
 * Checks whether the current pathname finishes by `/edit`
 * and the current page is editable by the user.
 * @private
 * @param  {User} user
 * @param  {Instance} instance
 * @returns {boolean}
 */
function isEditable (user, instance) {
  if (!user || !instance) {
    return false
  }
  return isEditableUserUtil(user, instance)
}

/**
 * Checks whether the current pathname finishes by `/new` or `/edit`
 * @private
 * @param  {string} path
 * @returns {boolean}
 */
function isEditOrNewRoute (path) {
  return isNewRouteUtil(path) || isEditRouteUtil(path)
}

/**
 * Checks whether the app is in editing mode.
 * @param  {string} path
 * @param  {User} user
 * @param  {Instance} instance
 * @returns {boolean}
 */
function isEditingRouteUtil (path, user, instance) {
  return isEditOrNewRoute(path) && isEditable(user, instance)
}

export {
  hasSideBarRouteUtil,
  isEditingRouteUtil
}
